import React, { useState } from 'react';

function HoverSwap({ 
  children, 
  hoverContent, 
  animationClass = '',
  className = '' 
}) {
  const [isHovered, setIsHovered] = useState(false);

  const handleInteractionStart = () => setIsHovered(true);
  const handleInteractionEnd = () => setIsHovered(false);

  return (
    <div 
      className={`hover-swap ${isHovered ? `hover-swap-active ${animationClass}` : ''} ${className}`}
      onMouseEnter={handleInteractionStart}
      onMouseLeave={handleInteractionEnd}
      onTouchStart={handleInteractionStart}
      onTouchEnd={handleInteractionEnd}
    >
      <div className={`hover-swap-default ${isHovered ? 'hover-swap-hidden' : ''}`}>
        {children}
      </div>
      <div className={`hover-swap-alternate ${isHovered ? '' : 'hover-swap-hidden'}`}>
        {hoverContent}
      </div>
    </div>
  );
}

export default HoverSwap;
